module.exports = __webpack_public_path__ + "img/1.efe8e18a.jpeg";